import React from "react";
import Cardabout from "../cardabout/Cardabout";
import NewsletterForm from "../newsletter/NewsletterForm";
import useTitle from "../useTitle";

const Acercade = () => {
    useTitle("Acerca de Aprender IA");
    return(
        <React.Fragment>
            <div className="w3-container w3-center w3-padding-64" style={{marginTop:'64px'}}>
                <div className="w3-flex" style={{justifyContent:'center', textAlign:'left', flexWrap:'wrap'}}>
                    <Cardabout/>
                    <NewsletterForm/>
                </div>
            </div>
        </React.Fragment>
    );
}

export default Acercade;